/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scenarist_SccInputs */



/**
* | output |
* | --- |
* | "Scenarist 1.0 (.scc)" |
*
* @param {Scenarist_SccInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scenarist_scc = /** @type {((inputs?: Scenarist_SccInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scenarist_SccInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Scenarist 1.0 (.scc)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Scenarist 1.0 (.scc)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scenarista 1.0 (.scc)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Scenarist 1.0 (.scc)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guionista 1.0 (.scc)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("场景 1.0 (.scc)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("シナリオリスト 1.0 (.scc)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सिनेरिस्ट 1.0 (.scc)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Scenarist 1.0 (.scc)")
	return /** @type {LocalizedString} */ ("Scenarist 1.0 (.scc)")
});